import { useEffect, useState } from "react";
import CrudPage from "./CrudPage";
import { api } from "@/lib/api";
import { Badge } from "@/components/ui/badge";

const companyOpts = [
  { value: "golmar", label: "Golmar" }, { value: "vitam", label: "Vitam" }, { value: "rotta66", label: "ROTTA66" }, { value: "fmg", label: "Consorzio FMG" },
];

export function Padroncini() {
  const [all, setAll] = useState([]);
  const [veicoli, setVeicoli] = useState([]);
  const reload = () => { api.get("/padroncini").then(r => setAll(r.data)); api.get("/veicoli").then(r => setVeicoli(r.data)); };
  useEffect(() => { reload(); }, []); // eslint-disable-line
  const nome = (p) => `${p.codice} · ${p.ragione_sociale || `${p.nome || ""} ${p.cognome || ""}`}`.trim();
  const pMap = Object.fromEntries(all.map(p => [p.id, nome(p)]));
  return (
    <CrudPage
      title="Padroncini"
      resource="padroncini"
      defaults={{ is_active: true, saldo_apertura: 0, pdf_layout: "moderno", percentuale_trattenuta: 5, conteggio_generale_id: null, mezzi_ids: [] }}
      prepareEdit={(it) => ({ ...it, mezzi_ids: veicoli.filter(v => v.padroncino_id === it.id).map(v => v.id) })}
      onSaved={reload}
      fields={[
        { key: "codice", label: "Codice" },
        { key: "numero_conteggio", label: "N. conteggio" },
        { key: "conteggio", label: "Conteggio", render: (it) => it.conteggio_generale_id
          ? <span className="text-xs" data-testid={`padroncini-collegato-${it.id}`}>→ {pMap[it.conteggio_generale_id] || "—"}</span>
          : <Badge variant="outline" className="h-5">Generale</Badge> },
        { key: "percentuale_trattenuta", label: "Tratt. %", render: (it) => `${String(it.percentuale_trattenuta ?? 5).replace(".", ",")}%` },
        { key: "nome", label: "Nome" },
        { key: "cognome", label: "Cognome" },
        { key: "targa", label: "Targa", render: (it) => <span className="font-mono text-xs">{veicoli.filter(v => v.padroncino_id === it.id).map(v => v.targa).join(", ") || "—"}</span> },
        { key: "iban", label: "IBAN" },
        { key: "telefono", label: "Telefono" },
        { key: "is_active", label: "Stato", render: (it) => it.is_active ? <Badge className="bg-green-600 h-5">Attivo</Badge> : <Badge variant="outline" className="h-5">Inattivo</Badge> },
      ]}
      formFields={[
        { key: "company", label: "Azienda", type: "select", options: companyOpts },
        { key: "codice", label: "Codice padroncino" },
        { key: "numero_conteggio", label: "N. conteggio generale (es. 57)" },
        { key: "conteggio_generale_id", label: "Tipo di conteggio", type: "select", clearable: true, full: true,
          noneLabel: "Conteggio GENERALE (principale)",
          options: (fm) => all.filter(p => p.company === fm.company && p.id !== fm.id && !p.conteggio_generale_id)
            .map(p => ({ value: p.id, label: `Collegato al generale di: ${nome(p)} (qui inserisco le spese)` })) },
        { key: "mezzi_ids", label: "Mezzi di questo conteggio", type: "multi", full: true, empty: "Nessun mezzo libero per questa azienda: crealo in Veicoli",
          options: (fm) => veicoli.filter(v => v.company === fm.company && (!v.padroncino_id || v.padroncino_id === fm.id || (fm.conteggio_generale_id && v.padroncino_id === fm.conteggio_generale_id)))
            .map(v => ({ value: v.id, label: v.padroncino_id && v.padroncino_id !== fm.id ? `${v.targa} (ora nel generale)` : v.targa })) },
        { key: "nome", label: "Nome" }, { key: "cognome", label: "Cognome" },
        { key: "ragione_sociale", label: "Ragione sociale" },
        { key: "codice_fiscale", label: "Codice fiscale" }, { key: "partita_iva", label: "Partita IVA" },
        { key: "iban", label: "IBAN", full: true },
        { key: "email", label: "Email" }, { key: "telefono", label: "Telefono" },
        { key: "whatsapp", label: "WhatsApp" }, { key: "tipo_contratto", label: "Tipo contratto" },
        { key: "saldo_apertura", label: "Saldo apertura (€)", type: "number" },
        { key: "percentuale_trattenuta", label: "Trattenuta % su fatturato (di base 5)", type: "number" },
        { key: "pdf_layout", label: "Layout PDF", type: "select", options: [{ value: "moderno", label: "Moderno" }, { value: "classico", label: "Classico Golmar" }] },
        { key: "note", label: "Note", full: true },
      ]}
    />
  );
}

export function Dipendenti() {
  const [padroncini, setPadroncini] = useState([]);
  const [veicoli, setVeicoli] = useState([]);
  useEffect(() => { api.get("/padroncini").then(r => setPadroncini(r.data)); api.get("/veicoli").then(r => setVeicoli(r.data)); }, []);
  const pMap = Object.fromEntries(padroncini.map(p => [p.id, `${p.codice} · ${p.nome || ""} ${p.cognome || ""}`.trim()]));
  const vMap = Object.fromEntries(veicoli.map(v => [v.id, v.targa]));
  return (
    <CrudPage
      title="Dipendenti dei padroncini"
      resource="dipendenti"
      defaults={{ is_active: true }}
      fields={[
        { key: "nome", label: "Nome" },
        { key: "cognome", label: "Cognome" },
        { key: "padroncino", label: "Padroncino", render: (it) => pMap[it.padroncino_id] || "—" },
        { key: "mezzo", label: "Mezzo", render: (it) => vMap[it.veicolo_id] || "—" },
        { key: "telefono", label: "Telefono" },
        { key: "scadenza_patente", label: "Scad. patente" },
        { key: "scadenza_carta_tachigrafica", label: "Scad. carta tach." },
        { key: "is_active", label: "Stato", render: (it) => it.is_active ? <Badge className="bg-green-600 h-5">Attivo</Badge> : <Badge variant="outline" className="h-5">Inattivo</Badge> },
      ]}
      formFields={[
        { key: "company", label: "Azienda", type: "select", options: companyOpts },
        { key: "padroncino_id", label: "Padroncino (datore di lavoro)", type: "select", options: padroncini.map(p => ({ value: p.id, label: pMap[p.id] })) },
        { key: "nome", label: "Nome" }, { key: "cognome", label: "Cognome" },
        { key: "codice_fiscale", label: "Codice fiscale" }, { key: "tipo_contratto", label: "Tipo contratto" },
        { key: "telefono", label: "Telefono" }, { key: "email", label: "Email" },
        { key: "iban", label: "IBAN", full: true },
        { key: "veicolo_id", label: "Mezzo assegnato", type: "select", clearable: true,
          options: (fm) => veicoli.filter(v => v.padroncino_id === fm.padroncino_id).map(v => ({ value: v.id, label: v.targa })) },
        { key: "scadenza_patente", label: "Scad. patente", type: "date" },
        { key: "scadenza_cqc", label: "Scad. CQC", type: "date" },
        { key: "scadenza_carta_tachigrafica", label: "Scad. carta tachigrafica", type: "date" },
        { key: "note", label: "Note", full: true },
      ]}
    />
  );
}

export function Veicoli() {
  const [padroncini, setPadroncini] = useState([]);
  const [veicoli, setVeicoli] = useState([]);
  useEffect(() => { api.get("/padroncini").then(r => setPadroncini(r.data)); api.get("/veicoli").then(r => setVeicoli(r.data)); }, []);
  const pMap = Object.fromEntries(padroncini.map(p => [p.id, `${p.nome || ""} ${p.cognome || ""}`.trim() || p.codice]));
  return (
    <CrudPage
      title="Veicoli"
      resource="veicoli"
      defaults={{ is_active: true }}
      fields={[
        { key: "targa", label: "Targa" },
        { key: "tipologia", label: "Tipologia" },
        { key: "marca", label: "Marca" },
        { key: "modello", label: "Modello" },
        { key: "padroncino", label: "Padroncino", render: (it) => pMap[it.padroncino_id] || "—" },
        { key: "scadenza_assicurazione", label: "Scad. ass." },
        { key: "broker_assicurazione", label: "Broker" },
        { key: "scadenza_revisione", label: "Scad. rev." },
        { key: "scadenza_tachigrafo", label: "Scad. tach." },
      ]}
      formFields={[
        { key: "company", label: "Azienda", type: "select", options: companyOpts },
        { key: "targa", label: "Targa" }, { key: "tipologia", label: "Tipologia (trattore/semirimorchio…)" },
        { key: "numero_conteggio", label: "N. conteggio del mezzo (es. 58)" },
        { key: "marca", label: "Marca" }, { key: "modello", label: "Modello" },
        { key: "padroncino_id", label: "Padroncino", type: "select", options: padroncini.map(p => ({ value: p.id, label: pMap[p.id] })) },
        { key: "mezzo_principale_id", label: "Abbinato a motrice (rimorchio/semirimorchio)", type: "select", clearable: true,
          options: (fm) => veicoli.filter(v => v.padroncino_id && v.padroncino_id === fm.padroncino_id && v.id !== fm.id && !v.mezzo_principale_id).map(v => ({ value: v.id, label: v.targa })) },
        { key: "scadenza_assicurazione", label: "Scad. assicurazione", type: "date" },
        { key: "broker_assicurazione", label: "Broker assicurazione" },
        { key: "compagnia_assicurazione", label: "Compagnia assicurativa" },
        { key: "scadenza_revisione", label: "Scad. revisione", type: "date" },
        { key: "scadenza_tachigrafo", label: "Scad. tachigrafo", type: "date" },
      ]}
    />
  );
}

export function Tessere() {
  const [padroncini, setPadroncini] = useState([]);
  const [veicoli, setVeicoli] = useState([]);
  useEffect(() => {
    api.get("/padroncini").then(r => setPadroncini(r.data));
    api.get("/veicoli").then(r => setVeicoli(r.data));
  }, []);
  const pMap = Object.fromEntries(padroncini.map(p => [p.id, `${p.nome || ""} ${p.cognome || ""}`.trim() || p.codice]));
  const vMap = Object.fromEntries(veicoli.map(v => [v.id, v.targa]));
  const tipi = [{ value: "dkv", label: "DKV" }, { value: "q8", label: "Q8" }, { value: "uta", label: "UTA" }, { value: "telepass_dkv", label: "Telepass DKV" }, { value: "telepass", label: "Telepass" }];
  const tipoLbl = Object.fromEntries(tipi.map(t => [t.value, t.label]));
  return (
    <CrudPage
      title="Tessere"
      resource="tessere"
      groups={{ key: "tipo", options: tipi }}
      defaults={{ is_active: true, tipo: "dkv" }}
      fields={[
        { key: "tipo", label: "Tipo", render: (it) => <Badge variant="outline" className="h-5 uppercase">{tipoLbl[it.tipo] || it.tipo}</Badge> },
        { key: "numero_tessera", label: "N. Tessera" },
        { key: "numero_jolly", label: "N. Jolly" },
        { key: "padroncino", label: "Padroncino", render: (it) => pMap[it.padroncino_id] || "—" },
        { key: "veicolo", label: "Veicolo", render: (it) => vMap[it.veicolo_id] || "—" },
        { key: "note", label: "Assegnata a / note", render: (it) => <span className="text-xs">{it.note || ""}{it.is_active === false && <Badge variant="outline" className="h-5 ml-1 text-red-600">bloccata</Badge>}</span> },
      ]}
      formFields={[
        { key: "company", label: "Azienda", type: "select", options: companyOpts },
        { key: "tipo", label: "Tipo", type: "select", options: tipi },
        { key: "numero_tessera", label: "Numero tessera" },
        { key: "numero_jolly", label: "Numero Jolly (DKV/UTA)" },
        { key: "padroncino_id", label: "Padroncino", type: "select", options: padroncini.map(p => ({ value: p.id, label: pMap[p.id] })) },
        { key: "veicolo_id", label: "Veicolo", type: "select", options: veicoli.map(v => ({ value: v.id, label: v.targa })) },
        { key: "note", label: "Assegnata a / note", full: true },
      ]}
    />
  );
}

export function Clienti() {
  return (
    <CrudPage
      title="Clienti"
      resource="clienti"
      defaults={{ is_active: true }}
      fields={[
        { key: "ragione_sociale", label: "Ragione sociale" },
        { key: "partita_iva", label: "P. IVA" },
        { key: "email", label: "Email" },
      ]}
      formFields={[
        { key: "company", label: "Azienda", type: "select", options: companyOpts },
        { key: "ragione_sociale", label: "Ragione sociale", full: true },
        { key: "partita_iva", label: "Partita IVA" },
        { key: "email", label: "Email" },
      ]}
    />
  );
}
